export default __webpack_public_path__ + "static/media/numpy.2950b746.svg";